import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
/**
 * DriveFileDTO 工厂类
 * 1. 根据 DriveFile.id 缓存 DriveFileDTO 单例
 * 2. 根据入参整合 DriveFileDTO 不同类型的创建
 */

import { DriveFileType } from "../../model/drive-file";
import { DriveFileDTO } from "./drive-file-dto";
import { LocalDriveFileDTO } from "./local-drive-file-dto";
export var DriveFileDTOFactory = /*#__PURE__*/function () {
  function DriveFileDTOFactory() {
    _classCallCheck(this, DriveFileDTOFactory);
    // DriveFileDTO 缓存 Map
    _defineProperty(this, "driveFileDTOCacheMap", void 0);
    this.driveFileDTOCacheMap = new Map();
  }

  /**
   * 构造 DriveFileDTO 实例
   * @param params
   */
  _createClass(DriveFileDTOFactory, [{
    key: "genDriveFileDTO",
    value: function () {
      var _genDriveFileDTO = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params, options) {
        var _params$driveFileType, driveFileType, driveFileDTO, _DriveFileType$CLOUD$, Generator, newDriveFileDTO, _driveFile$previewInf, _driveFile$previewInf2, _driveFile$previewInf3, _driveFile$previewInf4, _driveFileDTO$loadInc, _driveFileDTO2, _ref, previewInfo, previewInfoReqParams, downloadInfo, previewInfoCanTranscode, _driveFileDTO, driveFile, newOptions;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 默认值为云文件类型
              _params$driveFileType = params.driveFileType, driveFileType = _params$driveFileType === void 0 ? DriveFileType.CLOUD : _params$driveFileType; // 从缓存中获取
              _context.next = 3;
              return this.getCache(params, options);
            case 3:
              driveFileDTO = _context.sent;
              if (driveFileDTO) {
                _context.next = 11;
                break;
              }
              // eslint-disable-next-line @typescript-eslint/naming-convention
              Generator = (_DriveFileType$CLOUD$ = {}, _defineProperty(_DriveFileType$CLOUD$, DriveFileType.CLOUD, DriveFileDTO), _defineProperty(_DriveFileType$CLOUD$, DriveFileType.ATTACHMENT, DriveFileDTO), _defineProperty(_DriveFileType$CLOUD$, DriveFileType.LOCAL_ATTACHMENT, LocalDriveFileDTO), _DriveFileType$CLOUD$)[driveFileType] || DriveFileDTO;
              newDriveFileDTO = new Generator(params); // 加载基础信息
              _context.next = 9;
              return newDriveFileDTO.fetchDriveFile();
            case 9:
              // 设置缓存
              this.setCache(newDriveFileDTO);
              driveFileDTO = newDriveFileDTO;
            case 11:
              if (!(driveFileDTO && options !== null && options !== void 0 && options.incrementalConfig)) {
                _context.next = 21;
                break;
              }
              _ref = (options === null || options === void 0 ? void 0 : options.incrementalConfig) || {}, previewInfo = _ref.previewInfo, previewInfoReqParams = _ref.previewInfoReqParams, downloadInfo = _ref.downloadInfo, previewInfoCanTranscode = _ref.previewInfoCanTranscode;
              _driveFileDTO = driveFileDTO, driveFile = _driveFileDTO.driveFile;
              newOptions = {};
              if (previewInfo && !driveFile.previewInfo) Object.assign(newOptions, {
                previewInfo: previewInfo,
                previewInfoReqParams: previewInfoReqParams
              });
              if (downloadInfo && !driveFile.downloadInfo) Object.assign(newOptions, {
                downloadInfo: downloadInfo
              });
              if (previewInfoCanTranscode && !((_driveFile$previewInf = driveFile.previewInfo) !== null && _driveFile$previewInf !== void 0 && (_driveFile$previewInf2 = _driveFile$previewInf.audioMediaMetadata) !== null && _driveFile$previewInf2 !== void 0 && _driveFile$previewInf2.canTranscode) && !((_driveFile$previewInf3 = driveFile.previewInfo) !== null && _driveFile$previewInf3 !== void 0 && (_driveFile$previewInf4 = _driveFile$previewInf3.videoMediaMetadata) !== null && _driveFile$previewInf4 !== void 0 && _driveFile$previewInf4.canTranscode)) {
                Object.assign(newOptions, {
                  previewInfoCanTranscode: previewInfoCanTranscode
                });
              }
              _context.next = 20;
              return (_driveFileDTO$loadInc = (_driveFileDTO2 = driveFileDTO).loadIncrementalData) === null || _driveFileDTO$loadInc === void 0 ? void 0 : _driveFileDTO$loadInc.call(_driveFileDTO2, newOptions);
            case 20:
              // 更新完增量信息之后，更新缓存
              this.setCache(driveFileDTO);
            case 21:
              return _context.abrupt("return", driveFileDTO);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function genDriveFileDTO(_x, _x2) {
        return _genDriveFileDTO.apply(this, arguments);
      }
      return genDriveFileDTO;
    }()
  }, {
    key: "getCache",
    value: function () {
      var _getCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params, options) {
        var driveFileDTOCacheMap, id, _ref2, _ref2$cacheExpired, cacheExpired, _ref2$cacheIgnore, cacheIgnore, cache, timestamp, now;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              driveFileDTOCacheMap = this.driveFileDTOCacheMap;
              id = params.id;
              _ref2 = options || {}, _ref2$cacheExpired = _ref2.cacheExpired, cacheExpired = _ref2$cacheExpired === void 0 ? 60 * 1000 : _ref2$cacheExpired, _ref2$cacheIgnore = _ref2.cacheIgnore, cacheIgnore = _ref2$cacheIgnore === void 0 ? false : _ref2$cacheIgnore; // 忽略缓存
              if (!cacheIgnore) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              // 获取缓存
              cache = driveFileDTOCacheMap.get(id); // 无缓存
              if (cache) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return");
            case 8:
              timestamp = cache.timestamp; // 缓存失效
              now = Date.now();
              if (!(now - timestamp > cacheExpired)) {
                _context2.next = 13;
                break;
              }
              driveFileDTOCacheMap.delete(id);
              return _context2.abrupt("return");
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getCache(_x3, _x4) {
        return _getCache.apply(this, arguments);
      }
      return getCache;
    }()
  }, {
    key: "setCache",
    value: function setCache(driveFileDTO) {
      if (driveFileDTO.driveFile.id) {
        this.driveFileDTOCacheMap.set(driveFileDTO.driveFile.id, {
          data: driveFileDTO,
          timestamp: Date.now()
        });
      }
    }
  }]);
  return DriveFileDTOFactory;
}();
export var driveFileDTOFactory = new DriveFileDTOFactory();
//# sourceMappingURL=factory.js.map